import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RecaptchaComponent } from 'ng-recaptcha';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user_V2.service';
import { WavesModule, SelectModule, ToastService } from 'ng-uikit-pro-standard';
import { ThemeService } from 'src/app/services/theme.service'
import { AppConfigService } from 'src/app/app-config.service.service';


@Component({
  selector: 'app-register-cubeshop-user',
  templateUrl: './register-cubeshop-user.component.html',
  styleUrls: ['./register-cubeshop-user.component.scss']
})
export class RegisterCubeShopUserComponent implements OnInit {

  formProgressReport: FormGroup = new FormGroup({
    firstname: new FormControl({ value: '', disabled: false }, [Validators.required]),
    lastname: new FormControl({ value: '', disabled: false }, [Validators.required]),
    email: new FormControl({ value: '', disabled: false }, [Validators.required]),
  });

  ecomerceconcode: any;

  // formRegister = {
  //   firstname: '',
  //   lastname: '',
  //   email: '',
  // }

  hasproject: any;
  mycatchaResponse: any;  
  firstRegister = false;
  ready = false
  base64Logo: any

  public resolved(captchaResponse: string): void {
    this.mycatchaResponse = captchaResponse;
  }

  public onError(errorDetails: string): void {
  }  
  
  constructor(private fb: FormBuilder, private route: ActivatedRoute, private appConfigService: AppConfigService, public userService: UserService, private toast: ToastService, private router: Router, public ThemeService: ThemeService) { 

    
    
      
  }

    ngOnInit() {
      
    this.ThemeService.setNavaBar('navbar-disabled')

    this.base64Logo = this.ThemeService.getImgLogo();
    this.ecomerceconcode = this.ThemeService.getEcomerceconcode();
      
      // this.formProgressReport = this.fb.group(
      //   {
      //     firstname: ['', Validators.required],
      //     lastname: ['', [Validators.required]],
      //     email: ['', [Validators.required]]
      //   }
      // )

      this.initForm()
      // this.formProgressReport = new FormGroup({
      //   firstname: new FormControl({ value: '', disabled: false }, [Validators.required]),
      //   lastname: new FormControl({ value: '', disabled: false }, [Validators.required]),
      //   email: new FormControl({ value: '', disabled: false }, [Validators.required]),
      // });
    }

    initForm(){
      this.formProgressReport = new FormGroup({
        companyname: new FormControl({ value: null, disabled: false }, [Validators.required]),
        firstname: new FormControl({ value: null, disabled: false }, [Validators.required]),
        lastname: new FormControl({ value: null, disabled: false }, [Validators.required]),
        email: new FormControl({ value: null, disabled: false }, [Validators.required]),
      });
    }

    goLogin(){
      this.router.navigateByUrl('/login');   
    }

    saveUser(){
      if (!this.mycatchaResponse){
        this.toast.error('You must resolve catcha.');
        return 0;
      }
      let form = this.formProgressReport.value;
      form.captchacode = this.mycatchaResponse;

      if (!form.firstname || !form.lastname || !form.email ||!form.companyname){
        this.toast.error('All fields are necessary.');
        return 0;
      }

      console.log(this.formProgressReport);

      form.conncode = this.ecomerceconcode;

      this.userService.insertExtUsr(form).subscribe(result => {
        console.log(result);
        if (result[0].response == -2){
          this.viewEmail2 = true
        }
        else {
          this.viewEmail = true
        }
      })    
    }
    viewEmail2 = false
    viewEmail = false
    okClick(){
      this.viewEmail = false
      this.router.navigateByUrl('/login'); 
    }

}
